var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccEntertainment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7883",
    "data-name": "Rectangle 7883",
    width: 28,
    height: 28,
    transform: "translate(0.005)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7886",
    "data-name": "Rectangle 7886",
    width: 27.794,
    height: 19.793,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entertainment",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32412",
    "data-name": "Group 32412",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32415",
    "data-name": "Group 32415",
    transform: "translate(0.349 4.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32414",
    "data-name": "Group 32414",
    transform: "translate(-0.241 -0.172)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34651",
    "data-name": "Path 34651",
    d: "M27.536,15.078C27.07,12.666,25.1,2.432,25.1,2.432A2.532,2.532,0,0,0,22.672,0H4.864C3.514,0,2.707.965,2.432,2.432c0,0-2.432,13.52-2.432,13.937a3.43,3.43,0,0,0,6.681,1.092c.794-1.489,1.549-3.047,2.372-4.517h9.222c1.032,1.628,1.985,3.256,3,4.884a3.424,3.424,0,0,0,6.522-1.459,3.364,3.364,0,0,0-.258-1.29M12.567,6.462A1.1,1.1,0,0,1,11.525,7.6H9.43V9.609A1.161,1.161,0,0,1,8.289,10.75,1.1,1.1,0,0,1,7.147,9.7V7.6H5.142A1.161,1.161,0,0,1,4,6.462,1.1,1.1,0,0,1,5.053,5.321H7.147v-2A1.092,1.092,0,0,1,8.2,2.184h.089A1.1,1.1,0,0,1,9.43,3.236V5.321h2a1.1,1.1,0,0,1,1.142,1.052Zm4.07,1.231a1.231,1.231,0,1,1,1.231-1.231,1.231,1.231,0,0,1-1.231,1.231M19.228,10.7A1.231,1.231,0,1,1,20.459,9.47,1.231,1.231,0,0,1,19.228,10.7m0-5.906a1.231,1.231,0,1,1,1.231-1.231,1.231,1.231,0,0,1-1.231,1.231m2.69,2.9a1.231,1.231,0,1,1,1.231-1.231,1.231,1.231,0,0,1-1.231,1.231",
    transform: "translate(0 0)",
    fill: "#b3b6c6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccEntertainment);
export default __webpack_public_path__ + "static/media/mcc_entertainment.aca236e7d0e73c9a1310b832518aecef.svg";
export { ForwardRef as ReactComponent };